module.exports = __webpack_public_path__ + "officialStatic/img/detail-diffict5.37c30f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/solution/detail-diffict5.png
// module id = SnSu
// module chunks = 0